module.exports = __webpack_public_path__ + "media/images/diy/pinspot-removebg-preview-527690e49e8c716684c2f7f59ed0e23f.svg";